import type { CustomerKind, OrderRequestFormType } from 'api/models/mainservice';
import type { OrderRequestState } from 'pages/request/order/models';

export const orderRequestStateName = (state: OrderRequestState) =>
  `orderRequests.detail.state.${state}`;

export const getHouseholdFromOrderRequesFormType = (
  formType: OrderRequestFormType
): CustomerKind | undefined => {
  if (formType === 'CompanyOnly') return 'Company';

  if (formType === 'HouseholdOnly') return 'Household';

  return undefined;
};
